module.exports = __webpack_public_path__ + "static/media/logotransparent.226b3d0d.png";